(() => {
  if (customElements.get('decorta-rug-gallery')) return;
  class DecortaRugGallery extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-rug-thumbnail]');
        if (!button || !this.contains(button)) return;
        const image = this.querySelector('.decorta-rug-main-image');
        const link = this.querySelector('[data-rug-full]');
        if (!image || !link) return;
        image.removeAttribute('srcset');
        image.src = button.dataset.src;
        image.alt = button.dataset.alt;
        link.href = button.dataset.large;
        this.querySelectorAll('[data-rug-thumbnail]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
      });
    }
  }
  customElements.define('decorta-rug-gallery', DecortaRugGallery);
})();
